import { __awaiter, __generator } from "tslib";
import { getCurrentCart as getCurrentEcomCart } from '@wix/ambassador-ecom-v1-cart/http';
import { BOOKINGS_APP_DEF_ID } from '@wix/bookings-adapter-ooi-wix-sdk';
import { query } from '@wix/ambassador-bookings-reader-v2-extended-booking/http';
export var getCurrentCart = function (_a) {
    var httpClient = _a.httpClient;
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, httpClient.request(getCurrentEcomCart({}))];
                case 1: return [2 /*return*/, (_b.sent()).data];
            }
        });
    });
};
var cartPopulator = function (cart, _a) {
    var httpClient = _a.httpClient;
    return __awaiter(void 0, void 0, void 0, function () {
        var bookingIds, extendedBookings, error_1;
        var _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    bookingIds = (_b = cart === null || cart === void 0 ? void 0 : cart.lineItems) === null || _b === void 0 ? void 0 : _b.filter(function (lineItem) { var _a; return ((_a = lineItem.catalogReference) === null || _a === void 0 ? void 0 : _a.appId) === BOOKINGS_APP_DEF_ID; }).map(function (lineItem) { var _a; return (_a = lineItem.catalogReference) === null || _a === void 0 ? void 0 : _a.catalogItemId; });
                    if (!bookingIds || (bookingIds === null || bookingIds === void 0 ? void 0 : bookingIds.length) === 0) {
                        return [2 /*return*/, []];
                    }
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, httpClient.request(query({
                            query: {
                                filter: {
                                    id: { $in: bookingIds },
                                },
                            },
                        }))];
                case 2:
                    extendedBookings = ((_d = (_c = (_e.sent())) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.extendedBookings) || [];
                    return [2 /*return*/, extendedBookings];
                case 3:
                    error_1 = _e.sent();
                    throw new Error('An error occured trying to receive bookings from cart');
                case 4: return [2 /*return*/];
            }
        });
    });
};
export var getBookingsLineItemsOptions = function (config) { return __awaiter(void 0, void 0, void 0, function () {
    var isEcom, bookingsFromCurrentCart, options;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, config.isBookingsOnEcomPromise];
            case 1:
                isEcom = _a.sent();
                if (!isEcom) {
                    return [2 /*return*/, []];
                }
                return [4 /*yield*/, getBookingsFromCurrentCart(config)];
            case 2:
                bookingsFromCurrentCart = _a.sent();
                options = bookingsFromCurrentCart.map(function (booking) {
                    var _a, _b, _c, _d;
                    return ({
                        scheduleId: (_b = (_a = booking.bookedEntity) === null || _a === void 0 ? void 0 : _a.schedule) === null || _b === void 0 ? void 0 : _b.scheduleId,
                        sessionId: (_d = (_c = booking.bookedEntity) === null || _c === void 0 ? void 0 : _c.slot) === null || _d === void 0 ? void 0 : _d.sessionId,
                        numberOfParticipants: booking.numberOfParticipants,
                        contactDetails: booking.contactDetails,
                    });
                });
                return [2 /*return*/, options];
        }
    });
}); };
export var getBookingsFromCurrentCart = function (config) { return __awaiter(void 0, void 0, void 0, function () {
    var isEcom, currentCartResponse, currentCart, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, config.isBookingsOnEcomPromise];
            case 1:
                isEcom = _a.sent();
                if (!isEcom) {
                    return [2 /*return*/, []];
                }
                _a.label = 2;
            case 2:
                _a.trys.push([2, 5, , 6]);
                return [4 /*yield*/, getCurrentCart(config)];
            case 3:
                currentCartResponse = _a.sent();
                currentCart = currentCartResponse === null || currentCartResponse === void 0 ? void 0 : currentCartResponse.cart;
                return [4 /*yield*/, cartPopulator(currentCart, config)];
            case 4: return [2 /*return*/, (_a.sent()).map(function (extendedBooking) { return extendedBooking.booking; })];
            case 5:
                e_1 = _a.sent();
                return [2 /*return*/, []];
            case 6: return [2 /*return*/];
        }
    });
}); };
//# sourceMappingURL=getBookingsFromCurrentCart.js.map